export const localizeNumber = (value) => Intl.NumberFormat('en').format(value);

export const shortCompactLocalizeNumber = (value) =>
  new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
  }).format(value);
